// RequestRefLink
// --------------
// A request reference number rendered as a REAL <a href> to the request's URL, so
// the browser's native "Open in new tab" (right-click), and ctrl / cmd / middle
// click, all work. A plain left-click is intercepted to do in-app SPA navigation
// via `onOpen` (no full-page reload), and stopPropagation keeps a parent clickable
// row from also firing. Used on the request/task list screens (All Requests, My
// Requests, Responders Task List, Pickers Task List).

import { formatRef } from "../../utils/helpers";

function RequestRefLink({ href, refNo, onOpen, className, style }) {
  return (
    <a
      href={href}
      className={className}
      style={style}
      onClick={(e) => {
        // Never also trigger a parent row's onClick.
        e.stopPropagation();
        // Let the browser handle modified clicks (open in a new tab / window).
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        // Plain left-click → in-app navigation, no reload.
        e.preventDefault();
        if (onOpen) onOpen();
      }}
    >
      {formatRef(refNo)}
    </a>
  );
}

export { RequestRefLink };
